<template>
  <div>
    <div v-if="validatorsCount === 1">
      <ProjectSettingsSignaturesValidator :validation="item.validations[0]" :item="item" />
    </div>
    <span v-else-if="item.validations?.length" class="d-flex align-center">
      <app-icon v-if="allValidatorsValidated"
                icon-name="clock"
                icon-weight="far"
                size="small"
                class="text-tertiary mr-2"
      />
      <app-icon v-else
                icon-name="circle-check"
                icon-weight="fas"
                class="text-success"
                size="small"
      />
      <span v-t="{
          path: 'project.project-settings.signatures.ProjectSettingsSignaturesValidatorsSummary.multipleValidators',
          plural: item.validations.length - 1,
          args: {
            validatorName: item.validations[0].validator.fullName,
            count: item.validations.length - 1,
          },
        }"
      />
    </span>
  </div>
</template>

<script>
import ProjectSettingsSignaturesValidator from './ProjectSettingsSignaturesValidator.vue'

export default {
  name: 'ProjectSettingsSignaturesValidatorsSummary',
  components: { ProjectSettingsSignaturesValidator },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    allValidatorsValidated () {
      return this.item.validations.filter(validator => !validator.validated).length > 0
    },
    validatorsCount () {
      return this.item.validations?.length ?? 0
    },
  },
}
</script>
